<template>
  <el-dialog
    width="700px"
    :title="$t('pages.equipment.text353')"
    :visible.sync="langVisible"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="auto"
        :rules="rules"
        class="demo-ruleForm"
      >
        <el-form-item :label="$t('menu.errCode')">
          <el-input v-model="ruleForm.errorCode" style="width:500px;" disabled/>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text354')">
          <el-select v-model="ruleForm.lang" style="width:500px;" disabled :placeholder="$t('public.text5')">
            <el-option :label="$t('pages.equipment.text340')" value="zh"/>
            <el-option :label="$t('pages.equipment.text341')" value="en"/>
            <el-option :label="$t('pages.equipment.text342')" value="ja"/>
            <el-option :label="$t('pages.equipment.text345')" value="hr"/>
            <el-option :label="$t('pages.equipment.text344')" value="pl"/>
            <el-option :label="$t('pages.equipment.text343')" value="pt"/>
            <el-option :label="$t('pages.equipment.text346')" value="de"/>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text339')">
          <el-select v-model="ruleForm.hwType" style="width:500px;" disabled :placeholder="$t('public.text5')">
            <el-option :label="$t('pages.equipment.text178')" :value="10"/>
            <el-option :label="$t('pages.equipment.text202')" :value="15"/>
            <el-option :label="$t('pages.equipment.text203')" :value="20"/>
            <el-option :label="$t('pages.equipment.text204')" :value="25"/>
            <el-option :label="$t('pages.equipment.text205')" :value="30"/>
            <el-option :label="$t('pages.equipment.text206')" :value="35"/>
            <el-option :label="$t('pages.equipment.text207')" :value="40"/>
            <el-option :label="$t('pages.equipment.text208')" :value="45"/>
            <el-option :label="$t('pages.equipment.text347')" :value="50"/>
            <el-option :label="$t('pages.equipment.text348')" :value="55"/>
            <el-option :label="$t('pages.equipment.text349')" :value="60"/>
            <el-option :label="$t('pages.equipment.text350')" :value="65"/>
            <el-option :label="$t('pages.equipment.text362')" :value="70"/>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text355')">
          <el-input v-model="ruleForm.name" style="width:500px;"/>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text356')">
          <el-input v-model="ruleForm.forEngineer" style="width:500px;"/>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text357')">
          <el-input v-model="ruleForm.forUser" style="width:500px;"/>
        </el-form-item>
        <el-form-item :label="$t('pages.equipment.text358')">
           <el-input v-model="ruleForm.solution" type="textarea" :rows="6" style="width:500px;"/>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t("button.cancel") }}</el-button>
      <el-button type="primary" @click="submit">{{$t("button.determine")}}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        protocolId: null,
        errorCode: null,
        lang: null,
        name: null,
        forEngineer: null,
        forUser: null,
        solution: null,
        hwType: null,
      },
      rules: {
        name: {
          required: true,
          message: this.$t("public.text1"),
          trigger: "change",
        },
        forEngineer: {
          required: true,
          message: this.$t("public.text1"),
          trigger: "change",
        },
        forUser: {
          required: true,
          message: this.$t("public.text1"),
          trigger: "change",
        },
        solution: {
          required: true,
          message: this.$t("public.text1"),
          trigger: "change",
        }
      },
    };
  },
  // 监听弹窗类型
  watch: {
    langVisible(newValue) {
      if (newValue) {
        this.ruleForm.protocolId = this.codeInfo.protocolId;
        this.ruleForm.errorCode = this.codeInfo.errorCode;
        this.ruleForm.lang = this.codeInfo.lang;
        this.ruleForm.hwType = this.codeInfo.hwType;
        this.ruleForm.solution = this.codeInfo.solution;
        this.loadLang();
      }
    },
  },
  computed: {
    ...mapState(["platformData"]),
  },
  props: ["langVisible","codeInfo"],
  methods: {
    loadLang() {
      var params={
        "protocolId": this.ruleForm.protocolId,
        "errorCode": this.ruleForm.errorCode,
        "lang": this.ruleForm.lang,
      }
      this.request.errorLang(params).then((res) => {
        if (res.data!=null) {
          this.ruleForm.name=res.data.name;
          this.ruleForm.forEngineer=res.data.forEngineer;
          this.ruleForm.forUser=res.data.forUser;
          if (this.ruleForm.solution==null||this.ruleForm.solution=="") {
            this.ruleForm.solution=res.data.solution;
          }
        }
      });
    },
    //关闭弹窗
    handleClose() {
      this.ruleForm = {
        protocolId: null,
        errorCode: null,
        lang: null,
        name: null,
        forEngineer: null,
        forUser: null,
        solution: null,
        hwType: null,
      };
      this.$refs["ruleForm"].resetFields();
      this.$emit("dialogClose");
    },
    //提交
    submit() {
      const that=this;
      that.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          that.request.langEdit(that.ruleForm)
            .then(() => {
              that.$message.success(that.$t("public.text9"));
              that.$emit("codeList");
              that.handleClose();
            })
            .catch(() => {});
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
  width: 80%;
}
.firmware-content {
  display: flex;
}
.firmware-content a {
  margin-right: 20px;
}
</style>